import React from 'react';
import { getChildValue } from 'components/property-editors/utils/ProviderNodeUtils';
import './DisplayStringEditor.less';
import { IEditorProps } from './Editor';
import { useEditorId } from './hooks/useEditorId';
import { EditorLabel } from './EditorLabel';
import './DisplayStringEditor.less';

interface IEditorStepInfoProps extends IEditorProps {}

/**
 * Read Only string with a label
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function DisplayStringEditor({ id, child, path }: IEditorStepInfoProps) {
  [id] = useEditorId(path, id);
  const childValue = getChildValue(child);
  return (
    <EditorLabel editor={child} path={path} htmlFor={id}>
    <span className="dpc-display-string-editor">{(childValue as string) || ''}</span>
    </EditorLabel>
  );
}

